import { useContext, useEffect, useState } from "react";
import TextInput from "../../components/TextInput";
// import Button from "../../components/Button";

import Card from "../../components/Card";

import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { UserContext } from "../../context/userContext";
import { Alert, Button, Form, Input } from "antd";


const Login = () => {
  const [user, setUser] = useLocalStorage("user", null);

  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState(null);

  const [loading, setLoading] = useState(false);



  const { login } = useContext(UserContext)

  const handleLogin = async (e) => {

    // if (isDev) {
    //     setUser({ user: { name: "Delvin" }, token: "TOKEN_HERE" });

    //     navigate("/dashboard");

    //     return;

    // }


    setLoading(true);
    e.preventDefault();

    let response = await login({ username, password }, navigate);

    console.log("login res", response)

    if (response) setError(response)



    setLoading(false);
  };



  return (


    <section className="login-wrapper">
      <div className="d-flex">
        <div className="wallpaper-col" style={{ backgroundImage: `url("https://ardhmeria-ks.com/b2b/assets/bg.jpg")` }}>


        </div>
        <div className="login-col">
          <div className="login-container">


            <img src="https://ardhmeria-ks.com/b2b/assets/Ardhmeria_emblem.png" className="login-logo" />

            <h4 className="mb-4 text-center">Kyçu për të hyrë në sistem.</h4>



            <div className="form">
              {error && (
                <Alert message={error} type="error" showIcon className="mb-3" />
              )}

              <form onSubmit={handleLogin} >

                {/* <TextInput type="text" id="username" value={username} onChangeValue={(text) => setUsername(text)} placeholder="Perdoruesi" style={{ marginBottom: "10px" }} /> */}

                {/* <TextInput type="password" id="password" value={password} onChangeValue={(text) => setPassword(text)} placeholder="Fjalekalimi" style={{ marginBottom: "20px" }} /> */}

                <label htmlFor="username">Përdoruesi</label>
                <Input
                  id="username"
                  placeholder="Ju lutem shkruani përdoruesin!"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="mb-3 d-block"
                />

                <label htmlFor="password">Fjalëkalimi</label>
                <Input
                  id="password"
                  placeholder="Ju lutem shkruani fjalëkalimin!"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  className="mb-3 d-block"
                />



                <Button onClick={handleLogin} type="primary" loading={loading} iconPosition={"end"}>
                  {loading ? "Duke u kyçur" : "Kyçu"}
                </Button>
              </form>

              <p className="mt-5">Nëse keni ndonjë problem në çasje ju lutem kontaktoni në numrin <a href="whatsapp://send?abid=+383 44 222 226&text=Pershendetje">+383 44 222 226</a></p>
            </div>
          </div>
        </div>
      </div>
    </section>


  );
};

export default Login;